/* eslint-disable no-new */
import * as types from './mutation-define'
import axios from 'axios';
import msgpad_show from "../msgpad_show"

import Vue from 'vue'


const state = {
  items:[]
  /*{
        list: [],
        make_to_int  :0,
        multil_index :0,
        amount_less  :0,
        note : '',
        vip:{}
      }*/
}

// getters
const getters = {
  get_saved_order: (state, getters) => (index) => { if(index) return state.items[index];else return state.items}

}


// actions
const actions = {
	
}


// mutations
const mutations = {
  [types.SAVE_ORDER_TO_BACKUP](state, order) {
    if(order){
    	state.items.unshift(order)
    }
  },

  [types.REMOVE_BACKUP_ORDER](state, index) {
  	if(state.items[index]){
  		state.items.splice(index,1)
  	}
  }

}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/saved_orders_store.js